import React, { useEffect, useState, memo } from 'react';
import { useDispatch } from 'react-redux';
import {
  restoreAuthState,
  getUserDetail,
  getProfile,
} from '~store/user/actions/auth';
import { getUserCart, getCartProductCount } from '~store/cart/actions/cart';
import { isNative } from '~global/screens';
import AsyncStorage from '~global/storage';

const AuthBootstrap = memo(({ children }) => {
  const dispatch = useDispatch();
  const [authInitialized, setAuthInitialized] = useState(false);
  useEffect(() => {
    const initializeAppAuth = async () => {
      try {
        const userData = JSON.parse(await AsyncStorage.getItem('userData'));
        if (userData && Object.keys(userData).length) {
          await dispatch(restoreAuthState());
        }
      } catch (error) {
        console.log('Auth initialization error:', error);
      } finally {
        setAuthInitialized(true);
      }
    };

    const initializeWebAuth = async () => {
      dispatch(getUserDetail()).then((response) => {
        let isBuyNowQueryString = 0;
        if (!isNative) {
          const urlParams = new URLSearchParams(window.location.search);
          isBuyNowQueryString = urlParams.get('is_buy_now');
        }

        if (response?.isLoggedIn && !isBuyNowQueryString) {
          dispatch(getCartProductCount());
          dispatch(getUserCart());
        }

        if (response?.isLoggedIn && response?._id) {
          const params = {
            filter: { user_id: response._id, is_detail: true },
            fields:
              'children,current_mother_status,is_lilla_profiling_completed,interest',
          };
          dispatch(getProfile(params));
        }

        if (response && !response.isLoggedIn) {
          dispatch({
            type: 'babyRegistry/setIsAllowedAccessToRegistry',
            data: false,
          });
        }
        setAuthInitialized(true);
      });
    };

    if (isNative) {
      initializeAppAuth();
    } else {
      initializeWebAuth();
    }
  }, []);

  // Don't render children until auth is initialized
  if (!authInitialized) {
    return <></>;
  }

  return children;
});

AuthBootstrap.displayName = 'AuthBootstrap';
export default AuthBootstrap;
